import InspectionSheet from "@/pages/inspections/sheet";
import InspectionsManager from "@/pages/inspections/manager";
import InspectionsReport from "@/pages/inspections/report";

export const routeInspectionsManager = "/inspections/manager";
export const routeInspectionsReport = "/inspections/report";
export const routeInspectionSheet = "/inspections/sheet";
export const inspectionsManagerPermission = "ui.navbar.inspections.manager";
export const inspectionsReportPermission = "ui.navbar.inspections.report";

export const inspectionRoutes = [
	{
		path: routeInspectionsManager,
		element: <InspectionsManager />,
		permission: inspectionsManagerPermission,
	},
	{
		path: `${routeInspectionsManager}/:shiftId`,
		element: <InspectionsManager />,
		permission: inspectionsManagerPermission,
	},
	{
		path: routeInspectionsReport,
		element: <InspectionsReport />,
		permission: inspectionsReportPermission,
	},
	{
		path: `${routeInspectionSheet}/:inspectionId`,
		element: <InspectionSheet />,
		permission: inspectionsManagerPermission,
	},
];
